// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../../config/styles';

const styles = theme => ({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    boxShadow: GlobalStyles.color.COLOR_SHADOW,
    borderRadius: 15,
    padding: 15,
    margin: 10,
    width: 150,
    [theme.breakpoints.down(400)]: {
      width: '100%',
      margin: '5px 0',
      boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.2)',
      borderRadius: 10,
    },
  },
  mainInfoContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: '10px 0',
  },
  workTimeContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 5,
  },
  workTimeSubContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: '5px 0',
  },
  storeName: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
  },
  defaultBold: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    color: GlobalStyles.color.COLOR_BLACK_GREY,
  }
});

export default styles;
